import { css } from "@emotion/css"
import { Button } from "@material-ui/core"
import { ReactComponent as ExpandIcon } from "assets/expand.svg"

export const styles = {
  root: css`
    min-width: 0;
    & span {
      justify-content: flex-end;
    }
  `,
}

export function CloseDialogButton({ onClick }: { onClick: () => void }) {
  return (
    <Button className={styles.root} onClick={onClick}>
      <ExpandIcon />
    </Button>
  )
}
